class NSBoxWidth
{
	one: string = "272px";
	double: string = "560px";
	triple: string = "848px";
	quadruple: string = "1136px";
}

class NSBoxHeight
{
	box: string = "48px";
	header: string = "28px";
	total: string = "76px";
}

export class NSBox
{
	static width: NSBoxWidth = new NSBoxWidth();
	static height: NSBoxHeight = new NSBoxHeight();
}